import { 
    API_RESOURCE_LIST,
    API_RESOURCE_TREE_LIST, 
    API_RESOURCE_DELETE, 
    API_RESOURCE_DETAIL, 
    API_RESOURCE_SAVE,
    API_RESOURCE_TREE_DRAG 
} from '@/common/constants';
import { 
    get, 
    post, 
    del, 
    put 
} from '@/utils/http';

export const getResourceList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(API_RESOURCE_LIST, params);
};

export const getResourceTreeList = (rootId) => {
    return get(API_RESOURCE_TREE_LIST, rootId ? { rootId } : {});
};

export const getResourceDetail = (resourceId) => {
    return get(API_RESOURCE_DETAIL.replace(':resourceId', resourceId));
};

export const delResource = (resourceId) => {
    return del(API_RESOURCE_DELETE.replace(':resourceId', resourceId));
};

export const saveResource = (resource) => {
    if(resource.id==undefined||resource.id==''){
        return post(API_RESOURCE_SAVE, resource);
    }else{
        return put(API_RESOURCE_SAVE, resource);
    }       
};

export const updResource = (resource) => {
    return put(API_RESOURCE_SAVE, resource);
};

export const dragResourceTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(API_RESOURCE_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};
// Resource RESOURCE resource



// WEBPACK FOOTER //
// ./src/data-model/system/resource-model.js